module.exports = require("@wallaby-ui/haidi/src/js/common/constants");